// App imports.
import * as assessmentInfo from "./assessmentInfo";
import * as utility from "./utility";
import * as worker from "../baseWorker";

export enum AppPagesEnum {
  StartPage = 0,
  StartNewAssessment = 1,
  SelectStateAndYear = 2,
  Assessment1 = 3,
  Assessment2 = 4,
  Assessment3 = 5,
  Assessment4 = 6,
  Assessment5 = 7,
}

export enum Assessment1StepsEnum {
  EnterDataAverageExpenditures = 0,
  DisplaySeds = 1,
  PercentOfSeds = 2,
  ElectricFollowup = 3,
  NaturalGasFollowup = 4,
  FuelOilFollowup = 5,
  PropaneFollowup = 6,
  ActionPlanSummary = 7,
}
export enum Assessment1FuelStatusEnum {
  InRangeNoIssues = 0,
  UnderMin = 1,
  OverMax = 2,
  ZeroAverageExpenditure = 3,
  NoSEDSData = 4,
}
export class Assessment1FuelTypeInfo {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  computedAverageExpenditure?: number;
  sedsAverageExpenditure?: number;
  sedsMainHeatCode: string;
  viewAnyway: boolean;
  numHouseholds: number;
  IncludingEnergyUseChargesFlag: boolean;
  IncludingEnergyUseChargesDesc: string;
  IncludingEnergyDeliveryChargesFlag: boolean;
  IncludingEnergyDeliveryChargesDesc: string;
  IncludingEnergyOptionalChargesFlag: boolean;
  IncludingEnergyOptionalChargesDesc: string;
  Including12MonthOnlyFlag: boolean;
  Including12MonthOnlyDesc: string;
  IncludingComplete12MonthFlag: boolean;
  IncludingComplete12MonthDesc: string;
  IndicatingLessThan12MonthFlag: boolean;
  IndicatingLessThan12MonthDesc: string;
  ReportingAfterDiscountsFlag: boolean;
  ReportingAfterDiscountsDesc: string;
  ZeroAvgExpenditureDataReasonDesc: string;
  OtherReasonDesc: string;

  CheckOutliersFlag: boolean;
  CheckOutliersDesc: string;
  IncludeOnlyAmountBilledFlag: boolean;
  IncludeOnlyAmountBilledDesc: string;


  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string) {
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.computedAverageExpenditure = 0;
    this.sedsAverageExpenditure = 0;
    this.sedsMainHeatCode = '';
    this.viewAnyway = null;
    this.IncludingEnergyUseChargesFlag = null;
    this.IncludingEnergyUseChargesDesc = '';
    this.IncludingEnergyDeliveryChargesFlag = null;
    this.IncludingEnergyDeliveryChargesDesc = '';
    this.IncludingEnergyOptionalChargesDesc = '';
    this.Including12MonthOnlyFlag = null;
    this.Including12MonthOnlyDesc = '';
    this.IncludingComplete12MonthFlag = null;
    this.IncludingComplete12MonthDesc = '';
    this.IndicatingLessThan12MonthFlag = null;
    this.IndicatingLessThan12MonthDesc = '';
    this.ReportingAfterDiscountsFlag = null;
    this.ReportingAfterDiscountsDesc = '';
    this.ZeroAvgExpenditureDataReasonDesc = '';
    this.OtherReasonDesc = '';
    this.CheckOutliersFlag = null;
    this.IncludeOnlyAmountBilledFlag = null;

  }

  get averageExpenseGreaterThanSeds(): boolean {
    if (this.sedsAverageExpenditure === 0
      || this.sedsAverageExpenditure === null
      || this.computedAverageExpenditure === null
      || this.computedAverageExpenditure == 0) {
      return null;
    }
    else if (this.computedAverageExpenditure < this.sedsAverageExpenditure) {
      return false;
    }
    else {
      return true;
    }
  }

  get percentOfSedsStatus(): number {
    if (this.sedsAverageExpenditure === 0 || this.sedsAverageExpenditure === null) {
      return Assessment1FuelStatusEnum.NoSEDSData;
    }
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure == 0) {
      return Assessment1FuelStatusEnum.ZeroAverageExpenditure;
    }
    else if (this.computedAverageExpenditure / this.sedsAverageExpenditure < 0.5) {
      return Assessment1FuelStatusEnum.UnderMin;
    }
    else if (this.computedAverageExpenditure / this.sedsAverageExpenditure > 1.5) {
      return Assessment1FuelStatusEnum.OverMax
    }
    else {
      return Assessment1FuelStatusEnum.InRangeNoIssues
    }
  }
  get percentOfSedsString(): string {
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure === 0) {
      return 'N/A';
    }
    else if (this.sedsAverageExpenditure === 0
      || this.sedsAverageExpenditure === null) {
      return 'N/A';
    }
    let percent: number = Math.round((this.computedAverageExpenditure / this.sedsAverageExpenditure) * 100);
    return String(percent) + "%";
  }
  get percentSpendingLessString(): string {
    if (this.computedAverageExpenditure === null
      || this.sedsAverageExpenditure === 0
      || this.sedsAverageExpenditure === null) {
      return null;
    }
    let percent: number = Math.round((1 - (this.computedAverageExpenditure / this.sedsAverageExpenditure)) * 100);
    return String(percent) + "%";
  }
  get percentSpendingMoreString(): string {
    if (this.computedAverageExpenditure === null
      || this.sedsAverageExpenditure === 0
      || this.sedsAverageExpenditure === null) {
      return null;
    }
    let percent: number = Math.round(((this.computedAverageExpenditure / this.sedsAverageExpenditure) - 1) * 100);
    return String(percent) + "%";
  }
}
export class Assessment1FuelTypesStatusHolder {
  Electric: Assessment1FuelTypeInfo;
  NaturalGas: Assessment1FuelTypeInfo;
  FuelOil: Assessment1FuelTypeInfo;
  Propane: Assessment1FuelTypeInfo;
  FiscalYear: number;
  Grantee: number;

  constructor() {
    this.Electric = new Assessment1FuelTypeInfo("Electric", "Electric", "Electric heat", "Electric heating");
    this.NaturalGas = new Assessment1FuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas");
    this.FuelOil = new Assessment1FuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil");
    this.Propane = new Assessment1FuelTypeInfo("Propane", "Propane", "Propane", "Propane");
  }
}
export class Assessment1StepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showComputedAverageExpenditure: boolean;
  showSedsAverageExpenditure: boolean;
  showPercentOfSedsString: boolean;
  showPercentOfSedsStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showComputedAverageExpenditure: boolean,
    showSedsAverageExpenditure: boolean,
    showPercentOfSedsString: boolean,
    showPercentOfSedsStatus: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showComputedAverageExpenditure = showComputedAverageExpenditure;
    this.showSedsAverageExpenditure = showSedsAverageExpenditure;
    this.showPercentOfSedsString = showPercentOfSedsString;
    this.showPercentOfSedsStatus = showPercentOfSedsStatus;
  }
}

export enum Assessment2StepsEnum {
  TotalVendors = 0,
  VendorsRequested = 1,
  VendorsReceived = 2,
  VendorsStatus = 3,
  ElectricDetail = 4,
  NaturalGasDetail = 5,
  FuelOilDetail = 6,
  PropaneDetail = 7,
  ActionPlanSummary = 8,
}
export enum Assessment2FuelStatusEnum {
  OverMinNoIssues = 0,
  OverMinNotEnoughRequested = 1,
  OverMinNotEnoughReceived = 2,
  UnderMinNoIssues = 3,
  UnderMinNotEnoughRequested = 4,
  UnderMinNotEnoughReceived = 5,
  RequestedMoreThanTotal = 6,
  ReceivedMoreThanTotal = 7,
  DidNotReportRequested = 8,//screens don't currently allow this
  DidNotReportReceived = 9,//screens don't currently allow this
}
export class Assessment2FuelTypeInfo {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  requiredVendors: number;
  showAccountNumberQuestion: boolean;
  numTotalVendors?: number;
  numRequestedVendors?: number;
  numReceivedVendors?: number;
  clientWaiversMeetVendorRequirements: boolean;
  clientWaiversMeetVendorRequirementsDesc: string;
  vendorAgreementsHaveDataCollectionRequirements: boolean;
  vendorAgreementsHaveDataCollectionRequirementsDesc: string;
  vendorsAlertedTimelyManner: boolean;
  vendorsAlertedTimelyMannerDesc: string;
  vendorsUseAccountNumberFlag: boolean;
  vendorsUseAccountNumberDesc: string;

  setUpMeetingDesc: string;
  viewAnyway: boolean;
  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string, requiredVendors: number, showAccountNumberQuestion: boolean) {
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.requiredVendors = requiredVendors;
    this.showAccountNumberQuestion = showAccountNumberQuestion;
    this.numTotalVendors = null;
    this.numRequestedVendors = null;
    this.numReceivedVendors = null;
    this.clientWaiversMeetVendorRequirements = null;
    this.vendorAgreementsHaveDataCollectionRequirements = null;
    this.vendorsAlertedTimelyManner = null;
    this.viewAnyway = false;
    this.clientWaiversMeetVendorRequirements = null;
    this.clientWaiversMeetVendorRequirementsDesc = '';
    this.vendorAgreementsHaveDataCollectionRequirements = null;
    this.vendorAgreementsHaveDataCollectionRequirementsDesc = '';
    this.vendorsAlertedTimelyManner = null;
    this.vendorsAlertedTimelyMannerDesc = '';
    this.vendorsUseAccountNumberFlag = null;
    this.vendorsUseAccountNumberDesc = '';
    this.setUpMeetingDesc = '';
  }

  get showSetUpMeeting(): boolean {
    let setUpMeeting: boolean = false;
    if (this.clientWaiversMeetVendorRequirements == true
      && this.vendorAgreementsHaveDataCollectionRequirements == true
      && this.vendorsAlertedTimelyManner == true
      && (this.showAccountNumberQuestion == false || this.vendorsUseAccountNumberFlag == true)) {
      setUpMeeting = true;
    }
    return setUpMeeting;
  }
  get vendorsSubmittingDataStatus(): Assessment2FuelStatusEnum {
    let statusToReturn: number = 0;

    if (this.numTotalVendors != null && this.numRequestedVendors != null && this.numReceivedVendors != null) {

      if (this.numRequestedVendors > this.numTotalVendors) {
        statusToReturn = Assessment2FuelStatusEnum.RequestedMoreThanTotal;
      }
      else if (this.numReceivedVendors > this.numTotalVendors) {

        statusToReturn = Assessment2FuelStatusEnum.ReceivedMoreThanTotal;
      }
      //if fuelType.requiredVendors or more
      else if (this.numTotalVendors >= this.requiredVendors) {
        //IF numRequestedVendors ≥ 5… AND… numReceivedVendors  ≥ 5
        //Your data collection efforts for Electric Heat households have not been flagged
        if (this.numRequestedVendors >= this.requiredVendors && this.numReceivedVendors >= this.requiredVendors) {

          statusToReturn = Assessment2FuelStatusEnum.OverMinNoIssues;
        }
        //IF numRequestedVendors < 5
        //Your data collection efforts for Electric Heat households have been flagged because you did not request data from at least 5 electricity vendors
        else if (this.numRequestedVendors < this.requiredVendors) {

          statusToReturn = Assessment2FuelStatusEnum.OverMinNotEnoughRequested;
        }
        //IF numRequestedVendors ≥ 5 … AND… numReceivedVendors < 5
        //Your data collection efforts for Electric Heat households have been flagged because you requested but did not receive data from at least 5 electricity vendors in your state / territory.
        else if (this.numReceivedVendors < this.requiredVendors) {

          statusToReturn = Assessment2FuelStatusEnum.OverMinNotEnoughReceived;
        }
      }
      //if fewer than this.requiredVendors
      else {

        //IF numRequestedVendors = numTotalVendors … AND… numReceivedVendors = numTotalVendors
        //Your data collection efforts for Electric Heat households have not been flagged
        if (this.numReceivedVendors == this.numTotalVendors && this.numReceivedVendors && this.numTotalVendors) {

          statusToReturn = Assessment2FuelStatusEnum.UnderMinNoIssues;
        }
        //IF numRequestedVendors < numTotalVendors
        //Your data collection efforts for Electric Heat households have been flagged because your state / territory has fewer than 5 electricity vendors, but you did not request data from all of them.
        else if (this.numRequestedVendors < this.numTotalVendors) {

          statusToReturn = Assessment2FuelStatusEnum.UnderMinNotEnoughRequested;
        }
        //IF numReceivedVendors < numTotalVendors
        //Your data collection efforts for Electric Heat households have been flagged because your state / territory has fewer than 5 electricity vendors and you requested, but did not receive, data from all of them.
        else if (this.numReceivedVendors < this.numTotalVendors) {

          statusToReturn = Assessment2FuelStatusEnum.UnderMinNotEnoughReceived;
        }
      }
    }
    return statusToReturn;
  }
}
export class Assessment2StepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showTotalVendors: boolean;
  showVendorsRequested: boolean;
  showVendorsReceived: boolean;
  showStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showTotalVendors: boolean,
    showVendorsRequested: boolean,
    showVendorsReceived: boolean,
    showStatus: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showTotalVendors = showTotalVendors;
    this.showVendorsRequested = showVendorsRequested;
    this.showVendorsReceived = showVendorsReceived;
    this.showStatus = showStatus;
  }
}
export class Assessment2FuelTypesStatusHolder {
  Electric: Assessment2FuelTypeInfo;
  NaturalGas: Assessment2FuelTypeInfo;
  FuelOil: Assessment2FuelTypeInfo;
  Propane: Assessment2FuelTypeInfo;
  FiscalYear: number;
  Grantee: number;

  constructor() {
    this.Electric = new Assessment2FuelTypeInfo("Electric", "Electric", "Electric heat", "Electric heating", 5, false);
    this.NaturalGas = new Assessment2FuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas", 5, false);
    this.FuelOil = new Assessment2FuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil", 10, true);
    this.Propane = new Assessment2FuelTypeInfo("Propane", "Propane", "Propane", "Propane", 10, true);
  }
}

export enum Assessment3StepsEnum {
  AssistedHouseholds = 0,
  VendorAssignment = 1,
  VendorAssignmentResults = 2,
  VendorAssignmentResultsElectric = 3,
  VendorAssignmentResultsNaturalGas = 4,
  VendorAssignmentResultsFuelOil = 5,
  VendorAssignmentResultsPropane = 6,
  NumHouseholdsDataCollectedEntry = 7,
  NumHouseholdsDataCollectedOverview = 8,
  NumHouseholdsDataCollectedElectric = 9,
  NumHouseholdsDataCollectedElectricSup1Enter = 10,
  NumHouseholdsDataCollectedElectricSup1Result = 11,
  NumHouseholdsDataCollectedElectricSup2Enter = 12,
  NumHouseholdsDataCollectedElectricSup2Result = 13,
  NumHouseholdsDataCollectedElectricSup3Enter = 14,
  NumHouseholdsDataCollectedElectricSup3Result = 15,
  NumHouseholdsDataCollectedElectricSupResultOverview1 = 16,
  NumHouseholdsDataCollectedElectricSupResultOverview2 = 17,
  NumHouseholdsDataCollectedElectricSupResultOverview3 = 18,
  NumHouseholdsDataCollectedElectricSupResultOverview4 = 19,
  NumHouseholdsDataCollectedElectricSupResultOverview5 = 20,
  NumHouseholdsDataCollectedNaturalGas = 21,
  NumHouseholdsDataCollectedNaturalGasSup1Enter = 22,
  NumHouseholdsDataCollectedNaturalGasSup1Result = 23,
  NumHouseholdsDataCollectedNaturalGasSup2Enter = 24,
  NumHouseholdsDataCollectedNaturalGasSup2Result = 25,
  NumHouseholdsDataCollectedNaturalGasSup3Enter = 26,
  NumHouseholdsDataCollectedNaturalGasSup3Result = 27,
  NumHouseholdsDataCollectedNaturalGasSupResultOverview1 = 28,
  NumHouseholdsDataCollectedNaturalGasSupResultOverview2 = 29,
  NumHouseholdsDataCollectedNaturalGasSupResultOverview3 = 30,
  NumHouseholdsDataCollectedNaturalGasSupResultOverview4 = 31,
  NumHouseholdsDataCollectedNaturalGasSupResultOverview5 = 32,
  NumHouseholdsDataCollectedFuelOil = 33,
  NumHouseholdsDataCollectedFuelOilSup1Enter = 34,
  NumHouseholdsDataCollectedFuelOilSup1Result = 35,
  NumHouseholdsDataCollectedFuelOilSup2Enter = 36,
  NumHouseholdsDataCollectedFuelOilSup2Result = 37,
  NumHouseholdsDataCollectedFuelOilSup3Enter = 38,
  NumHouseholdsDataCollectedFuelOilSup3Result = 39,
  NumHouseholdsDataCollectedFuelOilSupResultOverview1 = 40,
  NumHouseholdsDataCollectedFuelOilSupResultOverview2 = 41,
  NumHouseholdsDataCollectedFuelOilSupResultOverview3 = 42,
  NumHouseholdsDataCollectedFuelOilSupResultOverview4 = 43,
  NumHouseholdsDataCollectedFuelOilSupResultOverview5 = 44,
  NumHouseholdsDataCollectedPropane = 45,
  NumHouseholdsDataCollectedPropaneSup1Enter = 46,
  NumHouseholdsDataCollectedPropaneSup1Result = 47,
  NumHouseholdsDataCollectedPropaneSup2Enter = 48,
  NumHouseholdsDataCollectedPropaneSup2Result = 49,
  NumHouseholdsDataCollectedPropaneSup3Enter = 50,
  NumHouseholdsDataCollectedPropaneSup3Result = 51,
  NumHouseholdsDataCollectedPropaneSupResultOverview1 = 52,
  NumHouseholdsDataCollectedPropaneSupResultOverview2 = 53,
  NumHouseholdsDataCollectedPropaneSupResultOverview3 = 54,
  NumHouseholdsDataCollectedPropaneSupResultOverview4 = 55,
  NumHouseholdsDataCollectedPropaneSupResultOverview5 = 56,
  ActionPlanSummary = 57,
}
export enum Assessment3VendorAssignedStatusEnum {
  Over95NoIssues = 0,
  Under95NotMeetTarget = 1,
}
export enum Assessment3HHDataReceivedStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
}
export enum Assessment3HHVendorsSelectedStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
}
export enum Assessment3HHServedByVendorsProvidingDataStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
}
export enum Assessment3RateOfReturnStatusEnum {
  Over75NoIssues = 0,
  Under75NotMeetTarget = 1,
}
export class Assessment3FuelTypeInfo {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  targetPercentHouseholdsCovered: number;
  numHouseholds?: number;
  numHouseholdsAssignedVendor?: number;
  numHouseholdsDataReceived?: number;
  numHouseholdsServedByVendorsSelected?: number;
  numHouseholdsServedByVendorsProvidingData?: number;
  viewAnyway: boolean;
  viewAnywayDataReceived: boolean;
  appIncludesMainHeatingTypeFlag: boolean;
  appIncludesMainHeatingTypeDesc: string;
  appIncludesVendorAndAcctNumFlag: boolean;
  appIncludesVendorAndAcctNumDesc: string;
  appIncludesClientWaiverFlag: boolean;
  appIncludesClientWaiverDesc: string;

  householdsServedByVendorsProvidingDataStatusDesc: string;
  householdsServedByVendorsSelectedStatusDesc: string;
  rateOfReturnStatusDesc: string;

  vendorsNotIncludeAllDataElementsFlag: boolean;
  vendorsNotIncludeAllDataElementsDesc: string;
  ableToMatchAccountsFlag: boolean;
  ableToMatchAccountsDesc: string;

  anyOtherIssuesAssignmentRateFlag: boolean;
  increaseNumberOfVendorsSelectedFlag: boolean;
  increaseNumberOfVendorsProvidingFlag: boolean;
  increaseRateOfReturnFlag: boolean;
  anyOtherIssuesAssignmentRateDesc: string;

  increaseDataDesc: string;
  get vendorAssignmentStatus(): number {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsAssignedVendor === null) {
      return null;
    }
    if (this.numHouseholdsAssignedVendor / this.numHouseholds >= 0.95) {
      return Assessment3VendorAssignedStatusEnum.Over95NoIssues;
    }
    else {
      return Assessment3VendorAssignedStatusEnum.Under95NotMeetTarget;
    }
  }
  get dataReceivedStatus(): number {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsDataReceived === null) {
      return null;
    }
    if (this.numHouseholdsDataReceived / this.numHouseholds >= this.targetPercentHouseholdsCovered) {
      return Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues;
    }
    else {
      return Assessment3HHDataReceivedStatusEnum.NotMeetTarget;
    }
  }
  get householdsServedByVendorsSelectedStatus(): number {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsServedByVendorsSelected === null) {
      return null;
    }
    if (this.numHouseholdsServedByVendorsSelected / this.numHouseholds >= this.targetPercentHouseholdsCovered) {
      return Assessment3HHVendorsSelectedStatusEnum.OverTargetNoIssues;
    }
    else {
      return Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget;
    }
  }
  get householdsServedByVendorsProvidingDataStatus(): number {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsServedByVendorsProvidingData === null) {
      return null;
    }
    if (this.numHouseholdsServedByVendorsProvidingData / this.numHouseholds >= this.targetPercentHouseholdsCovered) {
      return Assessment3HHServedByVendorsProvidingDataStatusEnum.OverTargetNoIssues;
    }
    else {
      return Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget;
    }
  }
  get rateOfReturnStatus(): number {
    if (this.numHouseholdsServedByVendorsProvidingData === null
      || this.numHouseholdsServedByVendorsProvidingData === 0
      || this.numHouseholdsDataReceived === null) {
      return null;
    }
    if (this.numHouseholdsDataReceived / this.numHouseholdsServedByVendorsProvidingData >= 0.75) {
      return Assessment3RateOfReturnStatusEnum.Over75NoIssues;
    }
    else {
      return Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget;
    }
  }
  get percentHouseholdsAssignedVendor(): string {
    if (this.numHouseholds == null
      || this.numHouseholds == 0
      || this.numHouseholdsAssignedVendor == null) {
      return null;
    }
    let percent: number = Math.round((this.numHouseholdsAssignedVendor / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get percentHouseholdsDataReceived(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsDataReceived === null) {
      return null;
    }
    let percent: number = Math.round((this.numHouseholdsDataReceived / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get percentHouseholdsServedByVendorsSelected(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsServedByVendorsSelected === null) {
      return null;
    }
    let percent: number = Math.round((this.numHouseholdsServedByVendorsSelected / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get percentHouseholdsServedByVendorsProvidingData(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsServedByVendorsProvidingData === null) {
      return null;
    }
    let percent: number = Math.round((this.numHouseholdsServedByVendorsProvidingData / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get percentRateOfReturn(): string {
    if (this.numHouseholdsServedByVendorsProvidingData === null
      || this.numHouseholdsServedByVendorsProvidingData === 0
      || this.numHouseholdsDataReceived === null) {
      return null;
    }
    let percent: number = Math.round((this.numHouseholdsDataReceived / this.numHouseholdsServedByVendorsProvidingData) * 100);
    return String(percent) + "%";
  }
  get targetPercentHouseholdsCoveredString(): string {
    return String(this.targetPercentHouseholdsCovered * 100) + "%";
  }
  get numHouseholdsVendorNotSelected(): number {
    return this.numHouseholds - this.numHouseholdsServedByVendorsSelected;
  }
  get percentHouseholdsVendorNotSelected(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsServedByVendorsSelected === null) {
      return null;
    }
    let percent: number = Math.round(((this.numHouseholds - this.numHouseholdsServedByVendorsSelected) / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get numHouseholdsSelectedVendorNotProvidingData(): number {
    return this.numHouseholdsServedByVendorsSelected - this.numHouseholdsServedByVendorsProvidingData;
  }
  get percentHouseholdsSelectedVendorNotProvidingData(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsServedByVendorsSelected === null
      || this.numHouseholdsServedByVendorsProvidingData === null) {
      return null;
    }
    let percent: number = Math.round(((this.numHouseholdsServedByVendorsSelected - this.numHouseholdsServedByVendorsProvidingData) / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get numHouseholdsVendorNotEnoughProvidingData(): number {
    return this.numHouseholdsServedByVendorsProvidingData - this.numHouseholdsDataReceived;
  }
  get percentHouseholdsVendorNotEnoughProvidingData(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsDataReceived === null
      || this.numHouseholdsServedByVendorsProvidingData === null) {
      return null;
    }
    let percent: number = Math.round(((this.numHouseholdsServedByVendorsProvidingData - this.numHouseholdsDataReceived) / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get displayIncreaseRateOfReturn(): boolean {
    if ((this.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
      && this.householdsServedByVendorsSelectedStatus === Assessment3HHVendorsSelectedStatusEnum.OverTargetNoIssues
      && this.householdsServedByVendorsProvidingDataStatus === Assessment3HHServedByVendorsProvidingDataStatusEnum.OverTargetNoIssues
      && this.rateOfReturnStatus === Assessment3RateOfReturnStatusEnum.Over75NoIssues)
      || (this.increaseDataDesc != null && this.increaseDataDesc != '')) {
      return true;
    }
    else {
      return false;
    }

  }

  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string, targetPercentHouseholdsCovered: number) {
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.targetPercentHouseholdsCovered = targetPercentHouseholdsCovered;
    this.numHouseholds = null;
    this.numHouseholdsAssignedVendor = null;
    this.numHouseholdsDataReceived = null;
    this.numHouseholdsServedByVendorsSelected = null;
    this.numHouseholdsServedByVendorsProvidingData = null;
    this.viewAnyway = null;
    this.viewAnywayDataReceived = null;
    this.appIncludesMainHeatingTypeFlag = null;
    this.appIncludesMainHeatingTypeDesc = '';
    this.appIncludesVendorAndAcctNumFlag = null;
    this.appIncludesVendorAndAcctNumDesc = '';
    this.appIncludesClientWaiverFlag = null;
    this.appIncludesClientWaiverDesc = '';
    this.householdsServedByVendorsProvidingDataStatusDesc = '';
    this.householdsServedByVendorsSelectedStatusDesc = '';
    this.rateOfReturnStatusDesc = '';
    this.vendorsNotIncludeAllDataElementsFlag = null;
    this.vendorsNotIncludeAllDataElementsDesc = '';
    this.ableToMatchAccountsFlag = null;
    this.ableToMatchAccountsDesc = '';

    this.anyOtherIssuesAssignmentRateFlag = null;
    this.increaseNumberOfVendorsSelectedFlag = null;
    this.increaseNumberOfVendorsProvidingFlag = null;
    this.increaseRateOfReturnFlag = null;
    this.anyOtherIssuesAssignmentRateDesc = '';
    this.increaseDataDesc = '';
  }
}
export class Assessment3FuelTypesStatusHolder {
  Electric: Assessment3FuelTypeInfo;
  NaturalGas: Assessment3FuelTypeInfo;
  FuelOil: Assessment3FuelTypeInfo;
  Propane: Assessment3FuelTypeInfo;
  FiscalYear: number;
  Grantee: number;

  constructor() {
    this.Electric = new Assessment3FuelTypeInfo("Electric", "Electric", "Electric heat", "Electric heating", 0.5);
    this.NaturalGas = new Assessment3FuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas", 0.5);
    this.FuelOil = new Assessment3FuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil", 0.2);
    this.Propane = new Assessment3FuelTypeInfo("Propane", "Propane", "Propane", "Propane", 0.2);
  }
}
export class Assessment3StepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showNumHouseholds: boolean;
  showNumHouseholdsAssignedVendor: boolean;
  showPercentHouseholdsAssignedVendor: boolean;
  showVendorAssignmentStatus: boolean;
  showNumHouseholdsDataReceived1: boolean;
  showpercentHouseholdsDataReceived: boolean;
  showDataReceivedStatus: boolean;
  showNumHouseholdsServedByVendorsSelected: boolean;
  showPercentHouseholdsServedByVendorsSelected: boolean;
  showHouseholdsServedByVendorsSelectedStatus: boolean;
  showNumHouseholdsDataReceived2: boolean;
  showNumHouseholdsServedByVendorsProvidingData: boolean;
  showPercentHouseholdsServedByVendorsProvidingData: boolean;
  showVendorsProvidingDataStatus: boolean;
  showPercentRateOfReturn: boolean;
  showRateOfReturnStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showNumHouseholds: boolean,
    showNumHouseholdsAssignedVendor: boolean,
    showPercentHouseholdsAssignedVendor: boolean,
    showVendorAssignmentStatus: boolean,
    showNumHouseholdsDataReceived1: boolean,
    showpercentHouseholdsDataReceived: boolean,
    showDataReceivedStatus: boolean,
    showNumHouseholdsServedByVendorsSelected: boolean,
    showPercentHouseholdsServedByVendorsSelected: boolean,
    showHouseholdsServedByVendorsSelectedStatus: boolean,
    showNumHouseholdsDataReceived2: boolean,
    showNumHouseholdsServedByVendorsProvidingData: boolean,
    showPercentHouseholdsServedByVendorsProvidingData: boolean,
    showVendorsProvidingDataStatus: boolean,
    showPercentRateOfReturn: boolean,
    showRateOfReturnStatus: boolean,
  ) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showNumHouseholds = showNumHouseholds;
    this.showNumHouseholdsAssignedVendor = showNumHouseholdsAssignedVendor;
    this.showPercentHouseholdsAssignedVendor = showPercentHouseholdsAssignedVendor;
    this.showVendorAssignmentStatus = showVendorAssignmentStatus;
    this.showNumHouseholdsDataReceived1 = showNumHouseholdsDataReceived1;
    this.showpercentHouseholdsDataReceived = showpercentHouseholdsDataReceived;
    this.showDataReceivedStatus = showDataReceivedStatus;
    this.showNumHouseholdsServedByVendorsSelected = showNumHouseholdsServedByVendorsSelected;
    this.showPercentHouseholdsServedByVendorsSelected = showPercentHouseholdsServedByVendorsSelected;
    this.showHouseholdsServedByVendorsSelectedStatus = showHouseholdsServedByVendorsSelectedStatus;
    this.showNumHouseholdsDataReceived2 = showNumHouseholdsDataReceived2;
    this.showNumHouseholdsServedByVendorsProvidingData = showNumHouseholdsServedByVendorsProvidingData;
    this.showPercentHouseholdsServedByVendorsProvidingData = showPercentHouseholdsServedByVendorsProvidingData;
    this.showVendorsProvidingDataStatus = showVendorsProvidingDataStatus;
    this.showPercentRateOfReturn = showPercentRateOfReturn;
    this.showRateOfReturnStatus = showRateOfReturnStatus;

  }
}

export enum Assessment4StepsEnum {
  checkAcctNum = 1,
  checkVendorCantFindAcct = 2,
  checkShareHHDataReceivedEachVendor = 3,
  checkAvgHeatExpendVsSedsPerVendor = 4,
  checkRangeReptByVendors = 5,
  procsForReviewingResults = 6,
  procsForAddingNewChecks = 7,
  procsForRemovingChecks = 8,
  ActionPlanSummary = 9,
}
export class Assessment4Model {
  FiscalYear: number;
  Grantee: number;
  checkAcctNumFlag: boolean;
  checkVendorCantFindAcctFlag: boolean;
  checkShareHHDataReceivedEachVendorFlag: boolean;
  checkAvgHeatExpendVsSedsPerVendorFlag: boolean;
  checkRangeReptByVendorsFlag: boolean;
  procsForReviewingResultsFlag: boolean;
  procsForAddingNewChecksFlag: boolean;
  procsForRemovingChecksFlag: boolean;
  checkAcctNumDesc: string;
  checkVendorCantFindAcctDesc: string;
  checkShareHHDataReceivedEachVendorDesc: string;
  checkAvgHeatExpendVsSedsPerVendorDesc: string;
  checkRangeReptByVendorsDesc: string;
  procsForReviewingResultsDesc: string;
  procsForAddingNewChecksDesc: string;
  procsForRemovingChecksDesc: string;

  constructor() {
    this.checkAcctNumFlag = null;
    this.checkVendorCantFindAcctFlag = null;
    this.checkShareHHDataReceivedEachVendorFlag = null;
    this.checkAvgHeatExpendVsSedsPerVendorFlag = null;
    this.checkRangeReptByVendorsFlag = null;
    this.procsForReviewingResultsFlag = null;
    this.procsForAddingNewChecksFlag = null;
    this.procsForRemovingChecksFlag = null;
    this.checkAcctNumDesc = null;
    this.checkVendorCantFindAcctDesc = null;
    this.checkShareHHDataReceivedEachVendorDesc = null;
    this.checkAvgHeatExpendVsSedsPerVendorDesc = null;
    this.checkRangeReptByVendorsDesc = null;
    this.procsForReviewingResultsDesc = null;
    this.procsForAddingNewChecksDesc = null;
    this.procsForRemovingChecksDesc = null;
  }
}


export enum Assessment5SedsStatusEnum {
  InRangeNoIssues = 0,
  OutOfRange = 1,
  ZeroAverageExpenditure = 2,
  NoSEDSData = 3,
}
export enum Assessment5StepsEnum {
  EnterDataAverageExpenditures = 0,
  PercentOfSeds = 1,
  TotalVendors = 2,
  VendorsReceived = 3,
  AssistedHouseholds = 4,
  NumHouseholdsDataCollectedOverview = 5,
  checkEntry = 6,
  checkResult = 7,
  resultsOverview = 8,
}
export class Assessment5FuelTypeInfo {
  name: string;
  description: string;
  targetPercentHouseholdsCovered: number;
  computedAverageExpenditure: number;
  sedsAverageExpenditure: number;
  sedsMainHeatCode: string;
  numTotalVendors: number;
  numRequiredVendors: number;
  numReceivedVendors: number;
  numHouseholds: number;
  numHouseholdsDataReceived: number;
  get percentOfSedsStatus(): number {
    if (this.sedsAverageExpenditure === 0 || this.sedsAverageExpenditure === null) {
      return Assessment1FuelStatusEnum.NoSEDSData;
    }
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure == 0) {
      return Assessment1FuelStatusEnum.ZeroAverageExpenditure;
    }
    else if (this.computedAverageExpenditure / this.sedsAverageExpenditure < 0.5) {
      return Assessment1FuelStatusEnum.UnderMin;
    }
    else if (this.computedAverageExpenditure / this.sedsAverageExpenditure > 1.5) {
      return Assessment1FuelStatusEnum.OverMax
    }
    else {
      return Assessment1FuelStatusEnum.InRangeNoIssues
    }
  }
  get percentOfSedsString(): string {
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure === 0) {
      return 'N/A';
    }
    else if (this.sedsAverageExpenditure === 0
      || this.sedsAverageExpenditure === null) {
      return 'N/A';
    }
    let percent: number = Math.round((this.computedAverageExpenditure / this.sedsAverageExpenditure) * 100);
    return String(percent) + "%";
  }
  get vendorsSubmittingDataStatus(): number {
    let statusToReturn: number = 0;

    if (this.numTotalVendors != null && this.numReceivedVendors != null) {
      if (Number(this.numReceivedVendors) > Number(this.numTotalVendors)) {
        statusToReturn = Assessment2FuelStatusEnum.ReceivedMoreThanTotal;
      }
      //if fuelType.requiredVendors or more
      else if (this.numTotalVendors >= this.numRequiredVendors) {
        if (this.numReceivedVendors >= this.numRequiredVendors) {
          statusToReturn = Assessment2FuelStatusEnum.OverMinNoIssues;
        }
        else if (this.numReceivedVendors < this.numRequiredVendors) {
          statusToReturn = Assessment2FuelStatusEnum.OverMinNotEnoughReceived;
        }
      }
      //if fewer than this.requiredVendors
      else {

        if (this.numReceivedVendors == this.numTotalVendors && this.numReceivedVendors && this.numTotalVendors) {
          statusToReturn = Assessment2FuelStatusEnum.UnderMinNoIssues;
        }
        else if (this.numReceivedVendors < this.numTotalVendors) {
          statusToReturn = Assessment2FuelStatusEnum.UnderMinNotEnoughReceived;
        }
      }
    }

    return statusToReturn;
  }


  get percentHouseholdsDataReceived(): string {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsDataReceived === null) {
      return null;
    }
    let percent: number = Math.round((this.numHouseholdsDataReceived / this.numHouseholds) * 100);
    return String(percent) + "%";
  }
  get dataReceivedStatus(): number {
    if (this.numHouseholds === null
      || this.numHouseholds === 0
      || this.numHouseholdsDataReceived === null) {
      return null;
    }
    if (this.numHouseholdsDataReceived / this.numHouseholds >= this.targetPercentHouseholdsCovered) {
      return Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues;
    }
    else {
      return Assessment3HHDataReceivedStatusEnum.NotMeetTarget;
    }
  }
  constructor(name: string, description: string, requiredVendors: number, targetPercentHouseholdsCovered: number) {
    this.name = name;
    this.description = description;
    this.targetPercentHouseholdsCovered = targetPercentHouseholdsCovered;
    this.numRequiredVendors = requiredVendors;
    this.numTotalVendors = null;
    this.computedAverageExpenditure = null;
    this.sedsAverageExpenditure = null;
    this.sedsMainHeatCode = '';
    this.numReceivedVendors = null;
    this.numHouseholds = null;
    this.numHouseholdsDataReceived = null;
  }
}
export class Assessment5FuelTypesStatusHolder {
  Electric: Assessment5FuelTypeInfo;
  NaturalGas: Assessment5FuelTypeInfo;
  FuelOil: Assessment5FuelTypeInfo;
  Propane: Assessment5FuelTypeInfo;
  FiscalYear: number;
  Grantee: number;

  checksCollectVendorInfoFlag: boolean;
  checksReviewDataSubmittedFlag: boolean;
  procedureReviewFindingsFlag: boolean;
  procedureAssessEffectivenessFlag: boolean;
  assessment1OverallStatus: number;

  getAssessment1OverallStatus(): number {

    let status: number = 0;
    if (this.Electric.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
      && this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
      && this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
      && this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
    ) {
      status = Assessment5SedsStatusEnum.InRangeNoIssues;
    }
    else if (this.Electric.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.Electric.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
      || this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
    ) {
      status = Assessment5SedsStatusEnum.OutOfRange;
    }
    else if (this.Electric.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
      || this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
    ) {
      status = Assessment5SedsStatusEnum.ZeroAverageExpenditure;
    }

    else if (this.Electric.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
      || this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
    ) {
      status = Assessment5SedsStatusEnum.NoSEDSData;
    }

    return status;
  }

  constructor() {
    this.Electric = new Assessment5FuelTypeInfo("Electric", "Electric", 5, 0.5);
    this.NaturalGas = new Assessment5FuelTypeInfo("NaturalGas", "Natural Gas", 5, 0.5);
    this.FuelOil = new Assessment5FuelTypeInfo("FuelOil", "Fuel Oil", 10, 0.2);
    this.Propane = new Assessment5FuelTypeInfo("Propane", "Propane", 10, 0.2);
    this.checksCollectVendorInfoFlag = null;
    this.checksReviewDataSubmittedFlag = null;
    this.procedureReviewFindingsFlag = null;
    this.procedureAssessEffectivenessFlag = null;

  }

  get testStatus(): boolean {
    return true;
  }


}
export class Assessment5StepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showComputedAverageExpenditure: boolean;
  showSedsAverageExpenditure: boolean;
  showPercentOfSedsString: boolean;
  showPercentOfSedsStatus: boolean;
  showTotalVendors: boolean;
  showVendorsRequested: boolean;
  showVendorsReceived: boolean;
  showStatus: boolean;
  showNumHouseholds: boolean;
  showNumHouseholdsDataReceived: boolean;
  showpercentHouseholdsDataReceived: boolean;
  showDataReceivedStatus: boolean;

  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showComputedAverageExpenditure: boolean,
    showSedsAverageExpenditure: boolean,
    showPercentOfSedsString: boolean,
    showPercentOfSedsStatus: boolean,
    showTotalVendors: boolean,
    showVendorsReceived: boolean,
    showStatus: boolean,
    showNumHouseholds: boolean,
    showNumHouseholdsDataReceived: boolean,
    showpercentHouseholdsDataReceived: boolean,
    showDataReceivedStatus: boolean
  ) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showComputedAverageExpenditure = showComputedAverageExpenditure;
    this.showSedsAverageExpenditure = showSedsAverageExpenditure;
    this.showPercentOfSedsString = showPercentOfSedsString;
    this.showPercentOfSedsStatus = showPercentOfSedsStatus;
    this.showVendorsRequested = false;
    this.showTotalVendors = showTotalVendors;
    this.showVendorsReceived = showVendorsReceived;
    this.showStatus = showStatus;
    this.showNumHouseholds = showNumHouseholds;
    this.showNumHouseholdsDataReceived = showNumHouseholdsDataReceived;
    this.showpercentHouseholdsDataReceived = showpercentHouseholdsDataReceived;
    this.showDataReceivedStatus = showDataReceivedStatus;
  }
}


/**
 * This function must be called once and only once from BaseLayout.
 */
export function createState(inParentComponent) {
  return {
    //----------------------------------------------------------------------------------------------
    //define the model
    //----------------------------------------------------------------------------------------------
    ErrorMessage: '',
    CreateAssessmentErrorMessage: '',
    ShowSpinner: false,
    UserInfo: {
      granteeId: -1,
      viewAll: false,
      loggedIn: false
    },
    //ScrollToTop:false,
    MainHeader: 'Overview',
    SEDS_DATA_OK: 'VLOK',
    SEDS_PM_DATA_BAD: 'NLBD',
    SEDS_PM_DATA_ZERO_REP: 'NLB2',
    SEDS_NOT_SERVED: 'NLOK',
    SEDS_INVALID_PM: 'INVP',
    Grantees: [],
    FiscalYears: [],
    SelectedYear: null,
    SelectedGranteeId: null,
    SelectedGranteeName: null,
    savedAssessments: [],
    SedsValueCodesAssociativeArray: [],
    selectedAssessmentTypeToCreate: null,
    CurrentAssessementStepIndex: Assessment2StepsEnum.TotalVendors,
    CurrentAppPage: AppPagesEnum.StartPage,
    CurrentEditingAssessmentKey: null,
    HouseholdsAssisted: null,

    //create an object to hold current status of all steps/table cells for all fuel types
    Assessment1FuelTypesStatus: new Assessment1FuelTypesStatusHolder(),
    Assessment1ShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment1Steps: [
      new Assessment1StepInfo(Assessment1StepsEnum.EnterDataAverageExpenditures, "", true, true, false, false, false),
      new Assessment1StepInfo(Assessment1StepsEnum.DisplaySeds, "", true, true, true, false, false),
      new Assessment1StepInfo(Assessment1StepsEnum.PercentOfSeds, "", true, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.ElectricFollowup, "Electric", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.NaturalGasFollowup, "NaturalGas", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.FuelOilFollowup, "FuelOil", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.PropaneFollowup, "Propane", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.ActionPlanSummary, "", false, false, false, false, false),
    ],

    //create an object to hold current status of all steps/table cells for all fuel types
    Assessment2FuelTypesStatus: new Assessment2FuelTypesStatusHolder(),
    Assessment2ShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment2Steps: [
      new Assessment2StepInfo(Assessment2StepsEnum.TotalVendors, "", true, true, false, false, false),
      new Assessment2StepInfo(Assessment2StepsEnum.VendorsRequested, "", true, true, true, false, false),
      new Assessment2StepInfo(Assessment2StepsEnum.VendorsReceived, "", true, true, true, true, false),
      new Assessment2StepInfo(Assessment2StepsEnum.VendorsStatus, "", true, true, true, true, true),
      new Assessment2StepInfo(Assessment2StepsEnum.ElectricDetail, "Electric", false, true, true, true, true),
      new Assessment2StepInfo(Assessment2StepsEnum.NaturalGasDetail, "NaturalGas", false, true, true, true, true),
      new Assessment2StepInfo(Assessment2StepsEnum.FuelOilDetail, "FuelOil", false, true, true, true, true),
      new Assessment2StepInfo(Assessment2StepsEnum.PropaneDetail, "Propane", false, true, true, true, true),
      new Assessment2StepInfo(Assessment2StepsEnum.ActionPlanSummary, "", false, false, false, false, false),
    ],
    Assessment3ShowNextStepDisabled: true,
    Assessment3Steps: [
      new Assessment3StepInfo(Assessment3StepsEnum.AssistedHouseholds, "", true, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.VendorAssignment, "", true, true, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.VendorAssignmentResults, "", true, true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.VendorAssignmentResultsElectric, "Electric", false, true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.VendorAssignmentResultsNaturalGas, "NaturalGas", false, true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.VendorAssignmentResultsFuelOil, "FuelOil", false, true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.VendorAssignmentResultsPropane, "Propane", false, true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedEntry, "", true, true, false, false, false, true, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedOverview, "", true, true, false, false, false, true, true, true, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectric, "Electric", false, true, false, false, false, true, true, true, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Enter, "Electric", false, true, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Result, "Electric", false, true, false, false, false, false, false, false, true, true, true, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Enter, "Electric", false, true, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Result, "Electric", false, true, false, false, false, false, false, false, false, false, false, false, true, true, true, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Enter, "Electric", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Result, "Electric", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, true, true),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview1, "Electric", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview2, "Electric", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview3, "Electric", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview4, "Electric", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSupResultOverview5, "Electric", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas, "NaturalGas", false, true, false, false, false, true, true, true, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Enter, "NaturalGas", false, true, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Result, "NaturalGas", false, true, false, false, false, false, false, false, true, true, true, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Enter, "NaturalGas", false, true, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Result, "NaturalGas", false, true, false, false, false, false, false, false, false, false, false, false, true, true, true, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Enter, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Result, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, true, true),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview1, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview2, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview3, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview4, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSupResultOverview5, "NaturalGas", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil, "FuelOil", false, true, false, false, false, true, true, true, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Enter, "FuelOil", false, true, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Result, "FuelOil", false, true, false, false, false, false, false, false, true, true, true, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Enter, "FuelOil", false, true, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Result, "FuelOil", false, true, false, false, false, false, false, false, false, false, false, false, true, true, true, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Enter, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Result, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, true, true),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview1, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview2, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview3, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview4, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSupResultOverview5, "FuelOil", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropane, "Propane", false, true, false, false, false, true, true, true, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Enter, "Propane", false, true, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Result, "Propane", false, true, false, false, false, false, false, false, true, true, true, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Enter, "Propane", false, true, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Result, "Propane", false, true, false, false, false, false, false, false, false, false, false, false, true, true, true, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Enter, "Propane", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Result, "Propane", false, false, false, false, false, false, false, false, false, false, false, true, true, false, false, true, true),

      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview1, "", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview2, "", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview3, "", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview4, "", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment3StepInfo(Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSupResultOverview5, "", false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false),

    ],
    Assessment3FuelTypesStatus: new Assessment3FuelTypesStatusHolder(),
    Assessment4ShowNextStepDisabled: false,
    Assessment4Model: new Assessment4Model(),

    Assessment5FuelTypesStatus: new Assessment5FuelTypesStatusHolder(),
    Assessment5ShowNextStepDisabled: false,
    Assessment5Steps: [
      new Assessment5StepInfo(Assessment5StepsEnum.EnterDataAverageExpenditures, "", true, true, true, false, false, false, false, false, false, false, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.PercentOfSeds, "", true, true, true, true, true, false, false, false, false, false, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.TotalVendors, "", true, false, false, false, false, true, true, false, false, false, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.VendorsReceived, "", true, false, false, false, false, true, true, true, false, false, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.AssistedHouseholds, "", true, false, false, false, false, false, false, false, true, true, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.NumHouseholdsDataCollectedOverview, "", true, false, false, false, false, false, false, false, true, true, true, true),
      new Assessment5StepInfo(Assessment5StepsEnum.checkEntry, "", false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.checkResult, "", false, false, false, false, false, false, false, false, false, false, false, false),
      new Assessment5StepInfo(Assessment5StepsEnum.resultsOverview, "", true, true, true, true, true, true, true, true, true, true, true, true),
    ],

    //----------------------------------------------------------------------------------------------


    //----------------------------------------------------------------------------------------------
    //Event handlers
    //----------------------------------------------------------------------------------------------
    getGridRowClass: function (viewAll: boolean, fuelName: string): string {
      let className: string = "";
      if (viewAll === false) {
        className = " row2 ";
      }
      else {
        switch (fuelName) {
          case "Electric":
            className = " row2 ";
            break;
          case "NaturalGas":
            className = " row3 ";
            break;
          case "FuelOil":
            className = " row4 ";
            break;
          case "Propane":
            className = " row5 ";
            break;
        }
      }
      return className;
    },
    assessment1GetFuelTypesArray: function (): Assessment1FuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment1FuelTypesStatus.Electric);
      fuelArray.push(this.state.Assessment1FuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment1FuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment1FuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),
    assessment1ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment1StepsEnum.EnterDataAverageExpenditures) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment1ShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment1ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment1Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment1FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment1ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment1StepsEnum.ActionPlanSummary;

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment1Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment1FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment1ViewAnyway: function (inEvent: any, fuelType: Assessment1FuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment1FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating), fuelType);
      newFuelType.viewAnyway = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment1FuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment1FuelTypesStatus: newFuelTypes,
      });
    }.bind(inParentComponent),
    assessment1ShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      //-------------------------------------------------------------------------
      //set next button enabled or disabled disabled
      //-------------------------------------------------------------------------
      //switch (assessmentStepIndex) {
      //    case Assessment1StepsEnum.EnterDataAverageExpenditures: {
      //        if(fuelTypesStatus.Electric.computedAverageExpenditure === null
      //          || fuelTypesStatus.NaturalGas.computedAverageExpenditure === null
      //          || fuelTypesStatus.FuelOil.computedAverageExpenditure === null
      //          || fuelTypesStatus.Propane.computedAverageExpenditure === null){
      //          showNextStepDisabled = true;
      //        }
      //        break;
      //    }
      //    case Assessment1StepsEnum.DisplaySeds: {
      if (fuelTypesStatus.Electric.computedAverageExpenditure === null
        || fuelTypesStatus.NaturalGas.computedAverageExpenditure === null
        || fuelTypesStatus.FuelOil.computedAverageExpenditure === null
        || fuelTypesStatus.Propane.computedAverageExpenditure === null) {
        showNextStepDisabled = true;
      }

      //        break;
      //    }
      //    default: {
      //        //if any fuel type has totalvendors == null or numRequestedVendors == null or recieved vendors, then true
      //          if(fuelTypesStatus.Electric.computedAverageExpenditure === null
      //            || fuelTypesStatus.NaturalGas.computedAverageExpenditure === null
      //            || fuelTypesStatus.FuelOil.computedAverageExpenditure === null
      //            || fuelTypesStatus.Propane.computedAverageExpenditure === null
      //            ){
      //            showNextStepDisabled = true;
      //          }
      //        break;
      //    }
      //}
      //-------------------------------------------------------------------------
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment1FieldChangeHandler: function (inEvent: any, fuelType: Assessment1FuelTypeInfo): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment1FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newFuelType[inEvent.target.name] = this.state.stringToNullOrBoolean(inEvent.target.value);
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Expenditure") > -1 && inEvent.target.id != 'ZeroAvgExpenditureDataReasonDesc') {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }
      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment1FuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;
      const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(
        newFuelTypes
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment1FuelTypesStatus: newFuelTypes,
        Assessment1ShowNextStepDisabled: showNextStepDisabled,
      });
      //set state
    }.bind(inParentComponent),
    assessment1ShowCatchallQuestionUnder: function (fuelType): boolean {
      let showCatchallQuestion: boolean = false;
      if (fuelType.computedAverageExpenditure === 0 && fuelType.numHouseholds > 0) {
        showCatchallQuestion = false;
      }
      if (fuelType.IncludingEnergyUseChargesFlag === true
        && fuelType.IncludingEnergyDeliveryChargesFlag === true
        && fuelType.IncludingComplete12MonthFlag === true
        && fuelType.IndicatingLessThan12MonthFlag === true
        && fuelType.ReportingAfterDiscountsFlag === true) {
        showCatchallQuestion = true;
      }
      else {
        showCatchallQuestion = false;
      }
      return showCatchallQuestion;
    }.bind(inParentComponent),
    assessment1ShowCatchallQuestionOver: function (fuelType): boolean {
      let showCatchallQuestion: boolean = false;
      if (fuelType.computedAverageExpenditure === 0 && fuelType.numHouseholds > 0) {
        showCatchallQuestion = false;
      }
      if (fuelType.IncludingEnergyOptionalChargesFlag === false
        && fuelType.Including12MonthOnlyFlag === true
        && fuelType.CheckOutliersFlag === true
        && fuelType.IncludeOnlyAmountBilledFlag === true) {
        showCatchallQuestion = true;
      }
      else {
        showCatchallQuestion = false;
      }
      return showCatchallQuestion;
    }.bind(inParentComponent),

    assessment2GetFuelTypesArray: function (): Assessment2FuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment2FuelTypesStatus.Electric);
      fuelArray.push(this.state.Assessment2FuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment2FuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment2FuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),
    assessment2GetDetailPagePreviousStep: function (fuelType: Assessment2FuelTypeInfo, currentIndex: number): number {

      //if no issues in table
      if ((fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNoIssues
        || fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNoIssues)
        && fuelType.viewAnyway != true) {
        currentIndex = currentIndex - 2;
      }
      else if (fuelType.clientWaiversMeetVendorRequirements
        && fuelType.vendorAgreementsHaveDataCollectionRequirements
        && fuelType.vendorsAlertedTimelyManner) {//if no issues on detail page, go to next detail page (skip action plan)
        currentIndex = currentIndex - 2;
      }
      else {//otherwise show action plan
        currentIndex = currentIndex - 1;
      }

      return currentIndex;
    },
    assessment2ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment2StepsEnum.ActionPlanSummary) {
        this.state.showSpinner();
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;
        const showNextStepDisabled = this.state.assessment2ShowNextStepDisabled(this.state.Assessment2FuelTypesStatus, newAssessmentStepIndex);

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment2Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment2FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }


        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment2ShowNextStepDisabled: showNextStepDisabled,
        });
        document.getElementById("app").scrollIntoView()

      }
    }.bind(inParentComponent),
    assessment2ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment2StepsEnum.ActionPlanSummary) {
        this.state.showSpinner();
        let newAssessmentStepIndex = Assessment2StepsEnum.ActionPlanSummary;

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment2Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment2FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()

      }
    }.bind(inParentComponent),
    assessment2ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment2StepsEnum.TotalVendors) {

        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;
        const showNextStepDisabled = this.state.assessment2ShowNextStepDisabled(this.state.Assessment2FuelTypesStatus, newAssessmentStepIndex);
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment2ShowNextStepDisabled: showNextStepDisabled,
        });
        document.getElementById("app").scrollIntoView()
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment2ShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      //-------------------------------------------------------------------------
      //set next button enabled or disabled disabled
      //-------------------------------------------------------------------------
      switch (assessmentStepIndex) {
        case Assessment2StepsEnum.TotalVendors: {
          //if any fuel type has totalvendors == null, then true
          if (fuelTypesStatus.Electric.numTotalVendors === null
            || fuelTypesStatus.NaturalGas.numTotalVendors === null
            || fuelTypesStatus.FuelOil.numTotalVendors === null
            || fuelTypesStatus.Propane.numTotalVendors === null) {
            showNextStepDisabled = true;
          }
          break;
        }
        case Assessment2StepsEnum.VendorsRequested: {
          //if any fuel type has totalvendors == null or numRequestedVendors == null, then true
          if (fuelTypesStatus.Electric.numTotalVendors === null
            || fuelTypesStatus.NaturalGas.numTotalVendors === null
            || fuelTypesStatus.FuelOil.numTotalVendors === null
            || fuelTypesStatus.Propane.numTotalVendors === null
            || (fuelTypesStatus.Electric.numTotalVendors > 0 && fuelTypesStatus.Electric.numRequestedVendors === null)
            || (fuelTypesStatus.NaturalGas.numTotalVendors > 0 && fuelTypesStatus.NaturalGas.numRequestedVendors === null)
            || (fuelTypesStatus.FuelOil.numTotalVendors > 0 && fuelTypesStatus.FuelOil.numRequestedVendors === null)
            || (fuelTypesStatus.Propane.numTotalVendors > 0 && fuelTypesStatus.Propane.numRequestedVendors === null)
          ) {
            showNextStepDisabled = true;
          }

          break;
        }
        default: {
          //if any fuel type has totalvendors == null or numRequestedVendors == null or recieved vendors, then true
          if (fuelTypesStatus.Electric.numTotalVendors === null
            || fuelTypesStatus.NaturalGas.numTotalVendors === null
            || fuelTypesStatus.FuelOil.numTotalVendors === null
            || fuelTypesStatus.Propane.numTotalVendors === null
            || (fuelTypesStatus.Electric.numTotalVendors > 0 && fuelTypesStatus.Electric.numRequestedVendors === null)
            || (fuelTypesStatus.NaturalGas.numTotalVendors > 0 && fuelTypesStatus.NaturalGas.numRequestedVendors === null)
            || (fuelTypesStatus.FuelOil.numTotalVendors > 0 && fuelTypesStatus.FuelOil.numRequestedVendors === null)
            || (fuelTypesStatus.Propane.numTotalVendors > 0 && fuelTypesStatus.Propane.numRequestedVendors === null)
            || (fuelTypesStatus.Electric.numTotalVendors > 0 && fuelTypesStatus.Electric.numReceivedVendors === null)
            || (fuelTypesStatus.NaturalGas.numTotalVendors > 0 && fuelTypesStatus.NaturalGas.numReceivedVendors === null)
            || (fuelTypesStatus.FuelOil.numTotalVendors > 0 && fuelTypesStatus.FuelOil.numReceivedVendors === null)
            || (fuelTypesStatus.Propane.numTotalVendors > 0 && fuelTypesStatus.Propane.numReceivedVendors === null)

          ) {
            //console.log(fuelTypesStatus);

            showNextStepDisabled = true;
          }
          break;
        }
      }
      //-------------------------------------------------------------------------
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment2ViewAnyway: function (inEvent: any, fuelType: Assessment2FuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment2FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.requiredVendors, fuelType.showAccountNumberQuestion), fuelType);
      newFuelType.viewAnyway = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment2FuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment2FuelTypesStatus: newFuelTypes,
      });
    }.bind(inParentComponent),
    assessment2FieldChangeHandler: function (inEvent: any, fuelType: Assessment2FuelTypeInfo): void {

      if (inEvent.target.id === "numTotalVendors"
        || inEvent.target.id === "numRequestedVendors"
        || inEvent.target.id === "numReceivedVendors") {

        //variables for fuel type variables
        let currentStatus = fuelType.vendorsSubmittingDataStatus;
        let currentTotalVendors: number = fuelType.numTotalVendors;
        let currentRequestedVendors: number = fuelType.numRequestedVendors;
        let currentReceivedVendors: number = fuelType.numReceivedVendors;

        //-------------------------------------------------------------------------
        //set status
        //-------------------------------------------------------------------------
        switch (inEvent.target.id) {
          case "numTotalVendors": {
            currentTotalVendors = this.state.nullOrNumberToNumber(inEvent.target.value);
            break;
          }
          case "numRequestedVendors": {
            currentRequestedVendors = this.state.nullOrNumberToNumber(inEvent.target.value);
            break;
          }
          case "numReceivedVendors": {
            currentReceivedVendors = this.state.nullOrNumberToNumber(inEvent.target.value);
            break;
          }
        }
        //-------------------------------------------------------------------------


        //create copy of passedFuelTypeObject
        let newFuelType = new Assessment2FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.requiredVendors, fuelType.showAccountNumberQuestion);
        newFuelType = Object.assign(newFuelType, fuelType);
        newFuelType.numTotalVendors = currentTotalVendors;
        newFuelType.numRequestedVendors = currentRequestedVendors;
        newFuelType.numReceivedVendors = currentReceivedVendors;

        //create a copy of the fuel types object
        let newFuelTypes = {};
        newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment2FuelTypesStatus);
        newFuelTypes[fuelType.name] = newFuelType;

        //set next button enabled or disabled disabled
        const showNextStepDisabled = this.state.assessment2ShowNextStepDisabled(newFuelTypes, this.state.CurrentAssessementStepIndex);


        //set state object
        this.setState({
          ErrorMessage: '',
          Assessment2FuelTypesStatus: newFuelTypes,
          Assessment2ShowNextStepDisabled: showNextStepDisabled,
        });
      }
      else {


        //create copy of passedFuelTypeObject
        let newFuelType = Object.assign(new Assessment2FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.requiredVendors, fuelType.showAccountNumberQuestion), fuelType);

        switch (inEvent.target.name) {
          case "clientWaiversMeetVendorRequirements": {
            newFuelType.clientWaiversMeetVendorRequirements = this.state.stringToNullOrBoolean(inEvent.target.value);
            break;
          }
          case "vendorAgreementsHaveDataCollectionRequirements": {
            newFuelType.vendorAgreementsHaveDataCollectionRequirements = this.state.stringToNullOrBoolean(inEvent.target.value);
            break;
          }
          case "vendorsAlertedTimelyManner": {
            newFuelType.vendorsAlertedTimelyManner = this.state.stringToNullOrBoolean(inEvent.target.value);
            break;
          }
          case "vendorsUseAccountNumberFlag": {
            newFuelType.vendorsUseAccountNumberFlag = this.state.stringToNullOrBoolean(inEvent.target.value);
            break;
          }
          case "clientWaiversMeetVendorRequirementsDesc": {
            newFuelType.clientWaiversMeetVendorRequirementsDesc = inEvent.target.value;
            break;
          }
          case "vendorAgreementsHaveDataCollectionRequirementsDesc": {
            newFuelType.vendorAgreementsHaveDataCollectionRequirementsDesc = inEvent.target.value;
            break;
          }
          case "vendorsAlertedTimelyMannerDesc": {
            newFuelType.vendorsAlertedTimelyMannerDesc = inEvent.target.value;
            break;
          }
          case "vendorsUseAccountNumberDesc": {
            newFuelType.vendorsUseAccountNumberDesc = inEvent.target.value;
            break;
          }
          case "setUpMeetingDesc": {
            newFuelType.setUpMeetingDesc = inEvent.target.value;
            break;
          }

        }

        //create a copy of the fuel types object
        let newFuelTypes = {};
        newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment2FuelTypesStatus);
        newFuelTypes[fuelType.name] = newFuelType;

        const showNextStepDisabled: boolean = (newFuelType.clientWaiversMeetVendorRequirements === null);
        //set state object
        this.setState({
          ErrorMessage: '',
          Assessment2FuelTypesStatus: newFuelTypes,
          Assessment2ShowNextStepDisabled: showNextStepDisabled,
        });

      }

    }.bind(inParentComponent),

    assessmentLoadSavedAssessment: async function (inAssessmentId: number, inAssessmentType: string): Promise<void> {
      this.state.showSpinner();

      //get grantees
      const baseWorker: worker.baseWorker = new worker.baseWorker();
      const grantees: worker.IGrantee[] = await baseWorker.getGrantees();

      const utilityWorker: utility.Worker = new utility.Worker();
      let sedsValueCodesAssociativeArray = [];

      try {
        sedsValueCodesAssociativeArray = await utilityWorker.getSedsCodeValues();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      //get SEDS years (TODO: check this.  Assume SEDS years are OK - may only apply to assessment 1)
      const fiscalYears: worker.IFiscalYear[] = await baseWorker.getSedsYears();
      this.setState({
        ErrorMessage: '',
        Grantees: grantees,
        FiscalYears: fiscalYears,
        selectedAssessmentTypeToCreate: inAssessmentType,
        SedsValueCodesAssociativeArray: sedsValueCodesAssociativeArray,
      });
      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      if (inAssessmentType.toString() === "1") {//note that assessment type being passed as a string
        let holder: Assessment1FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment1Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(holder, Assessment1StepsEnum.EnterDataAverageExpenditures);
        this.setState({
          ErrorMessage: '',
          Assessment1ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment1,
          CurrentAssessementStepIndex: Assessment1StepsEnum.EnterDataAverageExpenditures,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment1FuelTypesStatus: holder,
          MainHeader: "Assessment 1: Defining Data Requirements",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "2") {//note that assessment type being passed as a string
        let holder: Assessment2FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment2Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment2ShowNextStepDisabled(holder, Assessment2StepsEnum.TotalVendors);
        this.setState({
          ErrorMessage: '',
          Assessment2ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment2,
          CurrentAssessementStepIndex: Assessment2StepsEnum.TotalVendors,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment2FuelTypesStatus: holder,
          MainHeader: "Assessment 2: Data Collection",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "3") {//note that assessment type being passed as a string
        let holder: Assessment3FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment3Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
          fiscalYear: holder.FiscalYear,
          granteeId: holder.Grantee,
          numberOfAssistedHouseholdsAll: null,
          numberOfAssistedHouseholdsElectric: holder.Electric.numHouseholds,
          numberOfAssistedHouseholdsNaturalGas: holder.NaturalGas.numHouseholds,
          numberOfAssistedHouseholdsFuelOil: holder.FuelOil.numHouseholds,
          numberOfAssistedHouseholdsPropane: holder.Propane.numHouseholds,
          numberOfAssistedHouseholdsOther: null,
        };

        const showNextStepDisabled = this.state.assessment3ShowNextStepDisabled(holder, Assessment3StepsEnum.AssistedHouseholds);
        this.setState({
          ErrorMessage: '',
          HouseholdsAssisted: numHouseholdsAssisted,
          Assessment3ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment3,
          CurrentAssessementStepIndex: Assessment3StepsEnum.AssistedHouseholds,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment3FuelTypesStatus: holder,
          MainHeader: "Assessment 3: Data Recording & Processing",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "4") {//note that assessment type being passed as a string
        let model: Assessment4Model = null;
        try {
          model = await assessmentWorker.getAssessment4Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        this.setState({
          ErrorMessage: '',
          Assessment4Model: model,
          Assessment4ShowNextStepDisabled: false,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment4,
          CurrentAssessementStepIndex: Assessment4StepsEnum.checkAcctNum,
          SelectedYear: model.FiscalYear,
          SelectedGranteeId: model.Grantee,
          SelectedGranteeName: this.state.getGranteeName(model.Grantee),
          MainHeader: "Assessment 4: Data Checking Routines",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "5") {//note that assessment type being passed as a string
        let holder: Assessment5FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment5Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        holder.assessment1OverallStatus = holder.getAssessment1OverallStatus();
        this.setState({
          ErrorMessage: '',
          Assessment5ShowNextStepDisabled: false,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment5,
          CurrentAssessementStepIndex: Assessment5StepsEnum.EnterDataAverageExpenditures,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment5FuelTypesStatus: holder,
          MainHeader: "Overall Reliability Assessment",
        });
        document.getElementById("app").scrollIntoView()
      }
      this.state.hideSpinner();
    }.bind(inParentComponent),
    assessmentLoadActionPlan: async function (inAssessmentId: number, inAssessmentType: string): Promise<void> {
      this.state.showSpinner();
      //get grantees
      const baseWorker: worker.baseWorker = new worker.baseWorker();
      const grantees: worker.IGrantee[] = await baseWorker.getGrantees();

      const utilityWorker: utility.Worker = new utility.Worker();
      let sedsValueCodesAssociativeArray = [];
      try {
        sedsValueCodesAssociativeArray = await utilityWorker.getSedsCodeValues();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      //get SEDS years (TODO: check this.  Assume SEDS years are OK - may only apply to assessment 1)
      const fiscalYears: worker.IFiscalYear[] = await baseWorker.getSedsYears();
      this.setState({
        ErrorMessage: '',
        Grantees: grantees,
        FiscalYears: fiscalYears,
        SedsValueCodesAssociativeArray: sedsValueCodesAssociativeArray,
      });

      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      if (inAssessmentType.toString() === "1") {//note that assessment type being passed as a string
        let holder: Assessment1FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment1Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(holder, Assessment1StepsEnum.ActionPlanSummary);
        this.setState({
          ErrorMessage: '',
          Assessment1ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment1,
          CurrentAssessementStepIndex: Assessment1StepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment1FuelTypesStatus: holder,
          MainHeader: "Assessment 1: Defining Data Requirements",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "2") {//note that assessment type being passed as a string
        let holder: Assessment2FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment2Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment2ShowNextStepDisabled(holder, Assessment2StepsEnum.ActionPlanSummary);
        this.setState({
          ErrorMessage: '',
          Assessment2ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment2,
          CurrentAssessementStepIndex: Assessment2StepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment2FuelTypesStatus: holder,
          MainHeader: "Assessment 2: Data Collection",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "3") {//note that assessment type being passed as a string
        let holder: Assessment3FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment3Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment3ShowNextStepDisabled(holder, Assessment3StepsEnum.ActionPlanSummary);
        this.setState({
          ErrorMessage: '',
          Assessment3ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment3,
          CurrentAssessementStepIndex: Assessment3StepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment3FuelTypesStatus: holder,
          MainHeader: "Assessment 3: Data Recording & Processing",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "4") {//note that assessment type being passed as a string
        let model: Assessment4Model = null;
        try {
          model = await assessmentWorker.getAssessment4Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        this.setState({
          ErrorMessage: '',
          Assessment4Model: model,
          Assessment4ShowNextStepDisabled: false,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment4,
          CurrentAssessementStepIndex: Assessment4StepsEnum.ActionPlanSummary,
          SelectedYear: model.FiscalYear,
          SelectedGranteeId: model.Grantee,
          SelectedGranteeName: this.state.getGranteeName(model.Grantee),
          MainHeader: "Assessment 4: Data Checking Routines",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "5") {//note that assessment type being passed as a string
        let holder: Assessment5FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment5Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        holder.assessment1OverallStatus = holder.getAssessment1OverallStatus();
        this.setState({
          ErrorMessage: '',
          Assessment5ShowNextStepDisabled: false,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment5,
          CurrentAssessementStepIndex: Assessment5StepsEnum.resultsOverview,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment5FuelTypesStatus: holder,
          MainHeader: "Overall Reliability Assessment",
        });
        document.getElementById("app").scrollIntoView()
      }
      this.state.hideSpinner();
    }.bind(inParentComponent),

    assessment3ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment3StepsEnum.AssistedHouseholds) {

        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.ActionPlanSummary
          && this.state.Assessment3FuelTypesStatus.Propane.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropane;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.ActionPlanSummary
          && this.state.Assessment3FuelTypesStatus.Propane.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.ActionPlanSummary
          && this.state.Assessment3FuelTypesStatus.Propane.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.ActionPlanSummary
          && this.state.Assessment3FuelTypesStatus.Propane.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Result;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane
          && this.state.Assessment3FuelTypesStatus.FuelOil.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil;
        }

        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane
          && this.state.Assessment3FuelTypesStatus.FuelOil.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane
          && this.state.Assessment3FuelTypesStatus.FuelOil.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane
          && this.state.Assessment3FuelTypesStatus.FuelOil.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Result;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil
          && this.state.Assessment3FuelTypesStatus.NaturalGas.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas;
        }

        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil
          && this.state.Assessment3FuelTypesStatus.NaturalGas.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil
          && this.state.Assessment3FuelTypesStatus.NaturalGas.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil
          && this.state.Assessment3FuelTypesStatus.NaturalGas.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Result;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas
          && this.state.Assessment3FuelTypesStatus.Electric.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
          && this.state.Assessment3FuelTypesStatus.Electric.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedElectric;
        }

        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas
          && this.state.Assessment3FuelTypesStatus.NaturalGas.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas
          && this.state.Assessment3FuelTypesStatus.NaturalGas.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Result;
        }
        else if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas
          && this.state.Assessment3FuelTypesStatus.NaturalGas.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Result;
        }

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment2ShowNextStepDisabled: false,
        });
        document.getElementById("app").scrollIntoView()
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
      }
    }.bind(inParentComponent),
    assessment3ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment3StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectric
          && (this.state.Assessment3FuelTypesStatus.Electric.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
            || this.state.Assessment3FuelTypesStatus.Electric.numHouseholds == 0)
          && this.state.Assessment3FuelTypesStatus.Electric.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Result
          && this.state.Assessment3FuelTypesStatus.Electric.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Electric.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas;
        }


        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Result
          && this.state.Assessment3FuelTypesStatus.Electric.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Electric.viewAnywayDataReceived != true) {
          if (this.state.Assessment3FuelTypesStatus.Electric.rateOfReturnStatus === Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget) {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Enter;
          }
          else {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas;
          }
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Result
          && this.state.Assessment3FuelTypesStatus.Electric.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Electric.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas
          && (this.state.Assessment3FuelTypesStatus.NaturalGas.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
            || this.state.Assessment3FuelTypesStatus.NaturalGas.numHouseholds == 0)
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Result
          && this.state.Assessment3FuelTypesStatus.NaturalGas.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil;
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Result
          && this.state.Assessment3FuelTypesStatus.NaturalGas.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          if (this.state.Assessment3FuelTypesStatus.NaturalGas.rateOfReturnStatus === Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget) {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Enter;
          }
          else {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil;
          }
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Result
          && this.state.Assessment3FuelTypesStatus.NaturalGas.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.NaturalGas.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil;
        }


        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil
          && (this.state.Assessment3FuelTypesStatus.FuelOil.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
            || this.state.Assessment3FuelTypesStatus.FuelOil.numHouseholds == 0)
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropane;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Result
          && this.state.Assessment3FuelTypesStatus.FuelOil.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropane;
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Result
          && this.state.Assessment3FuelTypesStatus.FuelOil.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          if (this.state.Assessment3FuelTypesStatus.FuelOil.rateOfReturnStatus === Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget) {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Enter;
          }
          else {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropane;
          }
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Result
          && this.state.Assessment3FuelTypesStatus.FuelOil.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.FuelOil.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedPropane;
        }

        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane
          && (this.state.Assessment3FuelTypesStatus.Propane.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues
            || this.state.Assessment3FuelTypesStatus.Propane.numHouseholds == 0)
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.ActionPlanSummary;
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Result
          && this.state.Assessment3FuelTypesStatus.Propane.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.ActionPlanSummary;
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Result
          && this.state.Assessment3FuelTypesStatus.Propane.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          if (this.state.Assessment3FuelTypesStatus.Propane.rateOfReturnStatus === Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget) {
            newAssessmentStepIndex = Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Enter;
          }
          else {
            newAssessmentStepIndex = Assessment3StepsEnum.ActionPlanSummary;
          }
        }
        if (this.state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Result
          && this.state.Assessment3FuelTypesStatus.Propane.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget
          && this.state.Assessment3FuelTypesStatus.Propane.viewAnywayDataReceived != true) {
          newAssessmentStepIndex = Assessment3StepsEnum.ActionPlanSummary;
        }

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment3Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment3FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }


        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment3StepsEnum.ActionPlanSummary) {

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment3Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment3FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }


        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: Assessment3StepsEnum.ActionPlanSummary,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3ShowNextStepDisabled: function (): boolean {
      let showNextStepDisabled = false;
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment3FieldChangeHandler: function (inEvent: any, fuelType: Assessment3FuelTypeInfo): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment3FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.targetPercentHouseholdsCovered);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        if (inEvent.target.type === "checkbox") {
          if (inEvent.target.checked == true) {
            newFuelType[inEvent.target.name] = true;
          }
          else {
            newFuelType[inEvent.target.name] = false;
          }

        }
        else {
          newFuelType[inEvent.target.name] = this.state.stringToNullOrBoolean(inEvent.target.value);
        }


      }
      else if (inEvent.target && inEvent.target.id.indexOf("num") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }



      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3FuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;

      const showNextStepDisabled = this.state.assessment3ShowNextStepDisabled();

      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment3FuelTypesStatus: newFuelTypes,
        Assessment3ShowNextStepDisabled: showNextStepDisabled,
      });
      //set state
    }.bind(inParentComponent),
    assessment3ViewAnywayVendorAssigned: function (inEvent: any, fuelType: Assessment3FuelTypeInfo): void {
      //create copy of passedFuelTypeObject

      let newFuelType = Object.assign(new Assessment3FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.targetPercentHouseholdsCovered), fuelType);
      newFuelType.viewAnyway = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3FuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;
      //set state object
      this.setState({
        ErrorMessage: '',
        ShowSpinner: false,

        Assessment3FuelTypesStatus: newFuelTypes,
      });
    }.bind(inParentComponent),
    assessment3ViewAnywayDataReceived: function (inEvent: any, fuelType: Assessment3FuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment3FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.targetPercentHouseholdsCovered), fuelType);
      newFuelType.viewAnywayDataReceived = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3FuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //move to supplemental assessment
      let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment3FuelTypesStatus: newFuelTypes,
        CurrentAssessementStepIndex: newAssessmentStepIndex,
      });
    }.bind(inParentComponent),
    assessment3GetFuelTypesArray: function (): Assessment3FuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment3FuelTypesStatus.Electric);
      fuelArray.push(this.state.Assessment3FuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment3FuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment3FuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),

    assessment4ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment4StepsEnum.checkAcctNum) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment4ShowNextStepDisabled: false,
        });
        document.getElementById("app").scrollIntoView()
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment4ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment4Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment4Model
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment4ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary) {
        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment4Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment4Model
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: Assessment4StepsEnum.ActionPlanSummary,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment4FieldChangeHandler: function (inEvent: any): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newModel = new Assessment4Model();
      newModel = Object.assign(newModel, this.state.Assessment4Model);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newModel[inEvent.target.name] = this.state.stringToNullOrBoolean(inEvent.target.value);
      }
      else {
        newModel[inEvent.target.id] = inEvent.target.value;
      }

      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment4Model: newModel,
      });
      //set state
    }.bind(inParentComponent),

    assessment5ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment5StepsEnum.EnterDataAverageExpenditures) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment5ShowNextStepDisabled: false,
        });
        document.getElementById("app").scrollIntoView()
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment5ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment5StepsEnum.resultsOverview) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        const showNextStepDisabled = this.state.assessment5ShowNextStepDisabled(this.state.Assessment5FuelTypesStatus
          , newAssessmentStepIndex)

        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment5Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment5FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment5ShowNextStepDisabled: showNextStepDisabled,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment5ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment5StepsEnum.resultsOverview) {
        //update saved assessment details
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        try {
          const result = await assessmentWorker.updateAssessment5Details(this.state.CurrentEditingAssessmentKey
            , this.state.Assessment5FuelTypesStatus
          );
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: Assessment5StepsEnum.resultsOverview,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment5FieldChangeHandler: function (inEvent: any, fuelType: Assessment5FuelTypeInfo): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment5FuelTypeInfo(fuelType.name, fuelType.description, fuelType.numRequiredVendors, fuelType.targetPercentHouseholdsCovered);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newFuelType[inEvent.target.name] = this.state.stringToNullOrBoolean(inEvent.target.value);
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Expenditure") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else if (inEvent.target && inEvent.target.id.indexOf("num") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }
      //create a copy of the holder object
      let newFuelTypes = new Assessment5FuelTypesStatusHolder();
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment5FuelTypesStatus);
      newFuelTypes.assessment1OverallStatus = newFuelTypes.getAssessment1OverallStatus();
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;

      const showNextStepDisabled = this.state.assessment5ShowNextStepDisabled(newFuelTypes
        , this.state.CurrentAssessementStepIndex)

      newFuelTypes.assessment1OverallStatus = newFuelTypes.getAssessment1OverallStatus();

      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment5FuelTypesStatus: newFuelTypes,
        Assessment5ShowNextStepDisabled: showNextStepDisabled,
      });
      //set state
    }.bind(inParentComponent),
    assessment5HolderFieldChangeHandler: function (inEvent: any): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newHolder = new Assessment5FuelTypesStatusHolder();
      newHolder = Object.assign(newHolder, this.state.Assessment5FuelTypesStatus);
      //update the appropriate field
      newHolder[inEvent.target.name] = this.state.stringToNullOrBoolean(inEvent.target.value);
      newHolder.assessment1OverallStatus = newHolder.getAssessment1OverallStatus();
      const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(
        newHolder
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment5FuelTypesStatus: newHolder,
        Assessment5ShowNextStepDisabled: showNextStepDisabled,
      });
      //set state
    }.bind(inParentComponent),
    assessment5ShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      //-------------------------------------------------------------------------
      //set next button enabled or disabled disabled
      //-------------------------------------------------------------------------
      switch (assessmentStepIndex) {
        case Assessment5StepsEnum.EnterDataAverageExpenditures:
        case Assessment5StepsEnum.PercentOfSeds: {
          if (this.state.isNullOrEmpty(fuelTypesStatus.Electric.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.computedAverageExpenditure)
          ) {
            showNextStepDisabled = true;
          }
          break;
        }
        case Assessment5StepsEnum.TotalVendors:
        case Assessment5StepsEnum.VendorsReceived: {
          if
            (
            (this.state.isNullOrEmpty(fuelTypesStatus.Electric.numTotalVendors)
              || this.state.isNullOrEmpty(fuelTypesStatus.Electric.numReceivedVendors)
              && fuelTypesStatus.Electric.numTotalVendors > 0)
            ||
            (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.numTotalVendors)
              || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.numReceivedVendors)
              && fuelTypesStatus.NaturalGas.numTotalVendors > 0)
            ||
            (this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.numTotalVendors)
              || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.numReceivedVendors)
              && fuelTypesStatus.FuelOil.numTotalVendors > 0)
            ||
            (this.state.isNullOrEmpty(fuelTypesStatus.Propane.numTotalVendors)
              || this.state.isNullOrEmpty(fuelTypesStatus.Propane.numReceivedVendors)
              && fuelTypesStatus.Propane.numTotalVendors > 0)
          ) {
            showNextStepDisabled = true;
          }
          break;
        }
        case Assessment5StepsEnum.AssistedHouseholds:
        case Assessment5StepsEnum.NumHouseholdsDataCollectedOverview: {
          if (this.state.isNullOrEmpty(fuelTypesStatus.Electric.numHouseholds)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.numHouseholds)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.numHouseholds)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.numHouseholds)
            || this.state.isNullOrEmpty(fuelTypesStatus.Electric.numHouseholdsDataReceived)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.numHouseholdsDataReceived)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.numHouseholdsDataReceived)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.numHouseholdsDataReceived)
          ) {
            showNextStepDisabled = true;
          }
          break;
        }
      }
      //-------------------------------------------------------------------------
      return showNextStepDisabled;
    }.bind(inParentComponent),

    SelectStateAndYearShowPreviousStep: function (): void {
      this.setState({
        ErrorMessage: '',
        CurrentAppPage: AppPagesEnum.StartNewAssessment,
        SelectedYear: null,
        SelectedGranteeId: null,
        SelectedGranteeName: null,
        selectedAssessmentTypeToCreate: null,
        CurrentEditingAssessmentKey: null,
        Assessment1FuelTypesStatus: new Assessment1FuelTypesStatusHolder(),
        Assessment2FuelTypesStatus: new Assessment2FuelTypesStatusHolder(),
        Assessment3FuelTypesStatus: new Assessment3FuelTypesStatusHolder(),
        Assessment5FuelTypesStatus: new Assessment5FuelTypesStatusHolder(),
      });
      document.getElementById("app").scrollIntoView()
    }.bind(inParentComponent),
    SelectStateAndYearShowNextStep: async function (): Promise<void> {
      this.state.showSpinner();
      document.getElementById("app").scrollIntoView()
      let pageToGoTo: number = 0;
      let headerText = 'Overview';

      //IF WE'RE GOING TO AN EXISTING ASSESSMENT.  
      if (this.state.CurrentEditingAssessmentKey != null && this.state.CurrentEditingAssessmentKey != "") {
        switch (this.state.nullOrNumberToNumber(this.state.selectedAssessmentTypeToCreate)) {
          case 1:
            pageToGoTo = AppPagesEnum.Assessment1;
            headerText = "Assessment 1: Defining Data Requirements";
            break;
          case 2:
            pageToGoTo = AppPagesEnum.Assessment2;
            headerText = "Assessment 2: Data Collection";
            break;
          case 3:
            pageToGoTo = AppPagesEnum.Assessment3;
            headerText = "Assessment 3: Data Recording & Processing";
            break;
          case 4:
            pageToGoTo = AppPagesEnum.Assessment4;
            headerText = "Assessment 4: Data Checking Routines";
            break;
          case 5:
            pageToGoTo = AppPagesEnum.Assessment5;
            headerText = "Overall Reliability Assessment";
            break;
        }

        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAppPage: pageToGoTo,
          MainHeader: headerText,
        });

        document.getElementById("app").scrollIntoView()
        return;
      }
      else// create a new assessment
      {
        //for assessment 1 and 5, check if pm data exists
        let avgExpenditures: utility.IAverageExpenditureByFuel = {
          fiscalYear: this.state.SelectedYear,
          granteeId: this.state.SelectedGranteeId,
          validPMDataReported: true,
          sedsAverageExpenditureAll: null,
          sedsAverageExpenditureElectric: null,
          sedsAverageExpenditureCodeElectric: '',
          sedsAverageExpenditureNaturalGas: null,
          sedsAverageExpenditureCodeNaturalGas: '',
          sedsAverageExpenditureFuelOil: null,
          sedsAverageExpenditureCodeFuelOil: '',
          sedsAverageExpenditurePropane: null,
          sedsAverageExpenditureCodePropane: '',
          sedsAverageExpenditureOther: null,
          computedAverageExpenditureAll: null,
          computedAverageExpenditureElectric: null,
          computedAverageExpenditureNaturalGas: null,
          computedAverageExpenditureFuelOil: null,
          computedAverageExpenditurePropane: null,
          computedAverageExpenditureOther: null,
          numberOfAssistedHouseholdsElectric: null,
          numberOfAssistedHouseholdsNaturalGas: null,
          numberOfAssistedHouseholdsFuelOil: null,
          numberOfAssistedHouseholdsPropane: null,
          numberOfAssistedHouseholdsOther: null,
        };
        if (this.state.selectedAssessmentTypeToCreate == 1
          || this.state.selectedAssessmentTypeToCreate == 5) {
          //get seds data, averageExpenses and num households served
          const utilityWorker: utility.Worker = new utility.Worker();
          try {
            avgExpenditures = await utilityWorker.getSedsData(this.state.SelectedGranteeId, this.state.SelectedYear);
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
          //if no valid pm data reported for a previous year, display an error
          if (avgExpenditures.validPMDataReported === false) {
            const errormessage: string = `Your state did not file a complete Performance Measures Report for ${this.state.SelectedYear}.
                                                      Therefore, it is not possible to assess the quality of your data for that year.`;
            this.setState({
              ErrorMessage: '',
              CreateAssessmentErrorMessage: errormessage,
              ShowSpinner: false,
            });
            return;
          }
          else {
            this.setState({
              ErrorMessage: '',
              CreateAssessmentErrorMessage: '',
              ShowSpinner: false,
            });
          }
        }


        //save new assessment in database
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        let assesmentId: number = 0;
        try {
          assesmentId = await assessmentWorker.addAssessment(
            this.state.SelectedGranteeId
            , this.state.SelectedYear
            , this.state.selectedAssessmentTypeToCreate);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        switch (this.state.selectedAssessmentTypeToCreate) {
          case 1: {
            let showNextStepDisabled = this.state.Assessment1ShowNextStepDisabled;
            //update number of households assisted for each fuel
            let newFuelTypes: Assessment1FuelTypesStatusHolder = new Assessment1FuelTypesStatusHolder();
            newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment1FuelTypesStatus);
            newFuelTypes.Electric.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditureElectric;
            newFuelTypes.Electric.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodeElectric;
            newFuelTypes.NaturalGas.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditureNaturalGas;
            newFuelTypes.NaturalGas.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodeNaturalGas;
            newFuelTypes.FuelOil.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditureFuelOil;
            newFuelTypes.FuelOil.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodeFuelOil;
            newFuelTypes.Propane.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditurePropane;
            newFuelTypes.Propane.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodePropane;

            newFuelTypes.Electric.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureElectric;
            newFuelTypes.NaturalGas.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureNaturalGas;
            newFuelTypes.FuelOil.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureFuelOil;
            newFuelTypes.Propane.computedAverageExpenditure = avgExpenditures.computedAverageExpenditurePropane;
            newFuelTypes.Electric.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsElectric;
            newFuelTypes.NaturalGas.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsNaturalGas;
            newFuelTypes.FuelOil.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsFuelOil;
            newFuelTypes.Propane.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsPropane;

            if (newFuelTypes.Electric.computedAverageExpenditure === null
              || newFuelTypes.NaturalGas.computedAverageExpenditure === null
              || newFuelTypes.FuelOil.computedAverageExpenditure === null
              || newFuelTypes.Propane.computedAverageExpenditure === null) {
              showNextStepDisabled = true;
            }
            else {
              showNextStepDisabled = false;
            }
            pageToGoTo = AppPagesEnum.Assessment1;
            headerText = "Assessment 1: Defining Data Requirements";

            this.setState({
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment1StepsEnum.EnterDataAverageExpenditures,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment1FuelTypesStatus: newFuelTypes,
              Assessment1ShowNextStepDisabled: showNextStepDisabled,
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case 2: {
            pageToGoTo = AppPagesEnum.Assessment2;
            headerText = "Assessment 2: Data Collection";
            this.setState({
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment2StepsEnum.TotalVendors,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case 3: {
            let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
              fiscalYear: this.state.SelectedYear,
              granteeId: this.state.SelectedGranteeId,
              numberOfAssistedHouseholdsAll: null,
              numberOfAssistedHouseholdsElectric: null,
              numberOfAssistedHouseholdsNaturalGas: null,
              numberOfAssistedHouseholdsFuelOil: null,
              numberOfAssistedHouseholdsPropane: null,
              numberOfAssistedHouseholdsOther: null,
            };

            //get number of households assisted
            const utilityWorker: utility.Worker = new utility.Worker();
            numHouseholdsAssisted = await utilityWorker.getNumhouseHolds(this.state.SelectedGranteeId, this.state.SelectedYear);
            let showNextStepDisabled = this.state.Assessment3ShowNextStepDisabled;
            //update number of households assisted for each fuel
            let newFuelTypes: Assessment3FuelTypesStatusHolder = {
              FiscalYear: this.state.SelectedYear
              , Grantee: this.state.SelectedGranteeId
              , Electric: null
              , NaturalGas: null
              , FuelOil: null
              , Propane: null
            };
            newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3FuelTypesStatus);
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsElectric != null) {
              newFuelTypes.Electric.numHouseholds = numHouseholdsAssisted.numberOfAssistedHouseholdsElectric;
              newFuelTypes.NaturalGas.numHouseholds = numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas;
              newFuelTypes.FuelOil.numHouseholds = numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil;
              newFuelTypes.Propane.numHouseholds = numHouseholdsAssisted.numberOfAssistedHouseholdsPropane;
              showNextStepDisabled = false;

            }

            pageToGoTo = AppPagesEnum.Assessment3;
            headerText = "Assessment 3: Data Recording & Processing";
            this.setState({
              ErrorMessage: '',
              Assessment3ShowNextStepDisabled: showNextStepDisabled,
              HouseholdsAssisted: numHouseholdsAssisted,
              CurrentAssessementStepIndex: Assessment2StepsEnum.TotalVendors,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment3FuelTypesStatus: newFuelTypes,
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case 4: {
            this.setState({
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment4StepsEnum.checkAcctNum,
              ShowSpinner: false,
              CurrentAppPage: AppPagesEnum.Assessment4,
              MainHeader: "Assessment 4: Data Checking Routines:",
              CurrentEditingAssessmentKey: assesmentId,
              Assessment4Model: new Assessment4Model(),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case 5: {
            //update number of households assisted for each fuel
            let newFuelTypes: Assessment5FuelTypesStatusHolder = new Assessment5FuelTypesStatusHolder();
            let showNextStepDisabled: boolean = true;

            newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment5FuelTypesStatus);
            newFuelTypes.Electric.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditureElectric;
            newFuelTypes.Electric.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodeElectric;
            newFuelTypes.NaturalGas.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditureNaturalGas;
            newFuelTypes.NaturalGas.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodeNaturalGas;
            newFuelTypes.FuelOil.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditureFuelOil;
            newFuelTypes.FuelOil.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodeFuelOil;
            newFuelTypes.Propane.sedsAverageExpenditure = avgExpenditures.sedsAverageExpenditurePropane;
            newFuelTypes.Propane.sedsMainHeatCode = avgExpenditures.sedsAverageExpenditureCodePropane;
            newFuelTypes.Electric.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureElectric;
            newFuelTypes.NaturalGas.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureNaturalGas;
            newFuelTypes.FuelOil.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureFuelOil;
            newFuelTypes.Propane.computedAverageExpenditure = avgExpenditures.computedAverageExpenditurePropane;
            newFuelTypes.Electric.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsElectric;
            newFuelTypes.NaturalGas.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsNaturalGas;
            newFuelTypes.FuelOil.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsFuelOil;
            newFuelTypes.Propane.numHouseholds = avgExpenditures.numberOfAssistedHouseholdsPropane;
            showNextStepDisabled = this.state.assessment5ShowNextStepDisabled(newFuelTypes
              , Assessment5StepsEnum.EnterDataAverageExpenditures)
            newFuelTypes.assessment1OverallStatus = newFuelTypes.getAssessment1OverallStatus();
            this.setState({
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment5StepsEnum.EnterDataAverageExpenditures,
              ShowSpinner: false,
              CurrentAppPage: AppPagesEnum.Assessment5,
              MainHeader: "Overall Reliability Assessment",
              CurrentEditingAssessmentKey: assesmentId,
              Assessment5FuelTypesStatus: newFuelTypes,
              Assessment5ShowNextStepDisabled: showNextStepDisabled,
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
        }
      }
    }.bind(inParentComponent),
    SelectStateAndYearFieldChangeHandler: function (inEvent: any): void {
      //If we're updating grantee, then get grantee name and set that too
      let granteeName = this.state.SelectedGranteeName;//SelectedGranteeName
      if (inEvent.target.id == "SelectedGranteeId") {
        const granteeArray = this.state.Grantees.filter(e => { return e.granteeId == inEvent.target.value; });
        if (granteeArray.length == 0) {
        }
        else {
          granteeName = granteeArray[0].granteeName;
        }

      }
      this.setState({
        ErrorMessage: '',
        [inEvent.target.id]: inEvent.target.value,
        SelectedGranteeName: granteeName,
        // Clear the editing assessment key so changing year/state forces a
        // fresh assessment load instead of reusing the stale one.
        CurrentEditingAssessmentKey: null,
      });
    }.bind(inParentComponent),

    stringToNullOrBoolean: function (inString: string): boolean {
      if (inString === "true") {
        return true;
      }
      else if (inString === "false") {
        return false;
      }
      else {
        return null;
      }
    },
    startPageAddAssessment: function (): void {

      this.setState({
        ErrorMessage: '',
        MainHeader: 'Start a New Assessment',
        CurrentAppPage: AppPagesEnum.StartNewAssessment,
      });

      document.getElementById("app").scrollIntoView()
    }.bind(inParentComponent),
    startStartNewAssessementPageBack: function (): void {
      this.setState({
        ErrorMessage: '',
        MainHeader: 'Overview',
        CurrentAppPage: AppPagesEnum.StartPage,
      });
    }.bind(inParentComponent),
    startNewAssessementAssessmentSelected: async function (inSelectedAssessment: number): Promise<void> {
      this.state.showSpinner();
      //get grantees
      const baseWorker: worker.baseWorker = new worker.baseWorker();
      const grantees: worker.IGrantee[] = await baseWorker.getGrantees();

      const utilityWorker: utility.Worker = new utility.Worker();
      let sedsValueCodesAssociativeArray = [];
      try {
        sedsValueCodesAssociativeArray = await utilityWorker.getSedsCodeValues();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }


      //get SEDS years (TODO: check this.  Assume SEDS years are OK - may only apply to assessment 1)
      const fiscalYears: worker.IFiscalYear[] = await baseWorker.getSedsYears();

      //set current user grantee
      var newUserInfo: worker.IUserInfo = {
        granteeId: this.state.UserInfo.granteeId,
        viewAll: this.state.UserInfo.viewAll,
        loggedIn: this.state.UserInfo.loggedIn
      };
      if (this.state.UserInfo != null && this.state.UserInfo.granteeId != -1 && grantees.length > 0) {
        //get grantee name for current user
        var userGrantee = grantees.filter((element) => element.granteeId === this.state.UserInfo.granteeId);
        if (userGrantee.length > 0) {
          newUserInfo.granteeName = userGrantee[0].granteeName;
        }
      }

      const assessment1Holder: Assessment1FuelTypesStatusHolder = new Assessment1FuelTypesStatusHolder();
      const assessment2Holder: Assessment2FuelTypesStatusHolder = new Assessment2FuelTypesStatusHolder();
      const assessment3Holder: Assessment3FuelTypesStatusHolder = new Assessment3FuelTypesStatusHolder();
      const assessment4Model: Assessment4Model = new Assessment4Model();
      const assessment5Holder: Assessment5FuelTypesStatusHolder = new Assessment5FuelTypesStatusHolder();

      this.setState({
        ErrorMessage: '',
        Assessment1FuelTypesStatus: assessment1Holder,
        Assessment2FuelTypesStatus: assessment2Holder,
        Assessment3FuelTypesStatus: assessment3Holder,
        Assessment4Model: assessment4Model,
        Assessment5FuelTypesStatus: assessment5Holder,
        ShowSpinner: false,
        UserInfo: newUserInfo,
        Grantees: grantees,
        FiscalYears: fiscalYears,
        selectedAssessmentTypeToCreate: inSelectedAssessment,
        MainHeader: 'Select State and Year',
        CurrentAppPage: AppPagesEnum.SelectStateAndYear,
        SedsValueCodesAssociativeArray: sedsValueCodesAssociativeArray,
      });
    }.bind(inParentComponent),
    deleteSavedAssessment: async function (inAssessmentId: number, inAssessmentId2: string ): Promise<void> {
      // Delete from server.
      this.state.showSpinner();
      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      try {
        await assessmentWorker.deleteSavedAssessment(inAssessmentId, inAssessmentId2);
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      // Remove from list by creating a copy that does not include the current contact.
      const al = this.state.savedAssessments.filter((inElement) => inElement.assessmentId != inAssessmentId);
      // Update state.
      this.setState({
        ErrorMessage: '',
        savedAssessments: al,
        ShowSpinner: false,
      });

    }.bind(inParentComponent), /* End deleteContact(). */
    backToStart: async function (): Promise<void> {
      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();

      
      let newSavedAssessments: assessmentInfo.ISavedAssessmentInfo[] = null;
      try {
        newSavedAssessments = await assessmentWorker.listSavedAssessments();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }


      let newAssessment2FuelTypesStatus = new Assessment2FuelTypesStatusHolder();

      this.setState({
        ErrorMessage: '',
        MainHeader: 'Overview',
        Assessment2FuelTypesStatus: newAssessment2FuelTypesStatus,
        CurrentAppPage: AppPagesEnum.StartPage,
        ShowSpinner: false,
        savedAssessments: newSavedAssessments,
        selectedAssessmentTypeToCreate: null,
        CurrentAssessementStepIndex: Assessment2StepsEnum.TotalVendors,
        CurrentEditingAssessmentKey: null,
      });
    }.bind(inParentComponent),
    getGranteeName: function (inGranteeId: number): string {
      let granteeName: string = "";
      const granteeArray = this.state.Grantees.filter(e => { return Number(e.granteeId) === Number(inGranteeId); });
      if (granteeArray.length > 0) {
        granteeName = granteeArray[0].granteeName;
      }
      return granteeName;
    }.bind(inParentComponent),

    //----------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------
    //Helper functions
    //----------------------------------------------------------------------------------------------
    showError: function (errorMessage: string) {
      this.setState({
        ShowSpinner: false,
        ErrorMessage: errorMessage,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),

    setCurrentUserInfo: function (inUser: worker.IUserInfo): void {
      this.setState({
        ErrorMessage: '',
        UserInfo: inUser
        , SelectedGranteeId: inUser.granteeId
      });
    }.bind(inParentComponent),
    addAssessmentsToList: function (inAssessments: assessmentInfo.ISavedAssessmentInfo[]): void {
      ////copy all the elements from baseComponent.state.savedAssessments to a new array
      //const copyOfSavedAssessments: assessmentInfo.ISavedAssessmentInfo[] = this.state.savedAssessments.slice(0);
      ////push the new assessment into our copy array
      //copyOfSavedAssessments.push(inAssessment);

      this.setState({
        ErrorMessage: ''
        , savedAssessments: inAssessments
      });

    }.bind(inParentComponent),
    showSpinner: function () {
      this.setState({
        ErrorMessage: '',
        ShowSpinner: true,
      });
    }.bind(inParentComponent),
    hideSpinner: function () {
      this.setState({
        ShowSpinner: false,
      });
    }.bind(inParentComponent),
    nullOrNumberToNumber: function (inNumber: any): any {

      let origString = String(inNumber);
      if (String(inNumber).endsWith(".")) {
        inNumber += '0';
      }
      let notANumber: boolean = isNaN(Number(inNumber));

      //if it's a number
      if (notANumber === false) {
        if (origString == '') {
          return origString;
        }
        else {
          return Number(inNumber);
        }
      }
      else {
        return 0;
      }
    },
    scrollToTop: function () {
      const yOffset = -100;
      const element = document.getElementById("app");
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    },

    isNullOrEmpty: function (inString: any): boolean {
      if (inString === '' || inString === null) {
        return true;
      }
      else {
        return false;
      }
    }

    //----------------------------------------------------------------------------------------------

  };
} /* End createState(). */

